import RootLayout from "@/app/layout";
import { motion } from 'framer-motion';
import { Typography, Container, Box, List, ListItem, ListItemText } from '@mui/material';
import Head from 'next/head';
import { useEffect, useState } from "react";

export const metadata = {
  title: 'Marlene Gujan Architektur AG | Datenschutz',
  description: 'Datenschutzerklärung der Marlene Gujan Architektur AG in Igis. Erfahren Sie, wie wir Ihre persönlichen Daten schützen und verarbeiten.',
  keywords: 'Datenschutz, Marlene Gujan, Architektur, Igis, Datenschutzerklärung, persönliche Daten',
  canonicalUrl: 'https://www.gujan-architektur.ch/datenschutz'
}


export default function Datenschutz() {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch('/api/getDatenschutz')
      .then(response => response.json())
      .then(data => setData(data))
      .catch(error => console.error('Error fetching data:', error));
  }, []);
  
  return (
    <RootLayout>
      <Head>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta name="keywords" content={metadata.keywords} />
        <link rel="canonical" href={metadata.canonicalUrl} />
      </Head>
      <motion.section
        className="section-large"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2 }} // Adjust the animation duration as needed
      >
        <div className="section-header">
          <div className="section-title">
            <Typography variant="h2" component="h2" gutterBottom>
              Datenschutzerklärung
            </Typography>
            <Typography variant="h3" gutterBottom>
              (Mai 2024)
            </Typography>
          </div>
        </div>
        <div className="section-body">
          <Container maxWidth="full" className="no-padding">
            <Box sx={{ mt: 4 }}>
              <Typography variant="h3" component="h2">Einführung</Typography>
              <Typography variant="body2" paragraph>Der Schutz Ihrer Privatsphäre und Ihrer persönlichen Daten ist für uns bei gujan-architektur.ch von höchster Priorität. Wir halten uns strikt an die gesetzlichen Datenschutzbestimmungen und diese Datenschutzerklärung. In der Regel können Sie unsere Webseite nutzen, ohne persönliche Informationen preiszugeben.</Typography>
            </Box>
            <Box sx={{ mt: 4 }}>
              <Typography variant="h3" component="h2">Datenschutzbestimmungen</Typography>
              <List>
                {data.map((item, index) => (
                  <ListItem key={index} sx={{ display: 'block', mb: 2 }}>
                    <ListItemText
                      primary={<Typography variant="h6" component="h3">{item.titel}</Typography>}
                      secondary={<Typography variant="body2" paragraph>{item.beschreibung}</Typography>} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Container>
        </div>
      </motion.section>
    </RootLayout>
  )
}
